import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const TAB =
  'text-muted-foreground hover:text-foreground inline-flex h-7 items-center rounded-md px-3 text-sm font-medium whitespace-nowrap transition-colors';
const ACTIVE = 'bg-background text-foreground shadow-sm dark:bg-input/30';

/** All schedules and Upcoming: one route each, so a tab is a link with history. */
export function SchedulesNav() {
  const { t } = useTranslation('schedules');
  return (
    <div className="-mx-1 mb-4 overflow-x-auto px-1">
      <nav
        aria-label={t('nav.label')}
        className="bg-muted inline-flex h-9 items-center gap-0.5 rounded-lg p-[3px]"
      >
        <Link
          to="/org/schedules"
          activeOptions={{ exact: true, includeSearch: false }}
          className={TAB}
          activeProps={{ className: ACTIVE }}
        >
          {t('nav.all')}
        </Link>
        <Link
          to="/org/schedules/upcoming"
          className={TAB}
          activeProps={{ className: ACTIVE }}
          data-tour="schedules.list.upcoming"
        >
          {t('nav.upcoming')}
        </Link>
      </nav>
    </div>
  );
}
